export default "/images/91cb8c95a6c4d0ba2207e6e48b951e65.avif";